module.exports = __webpack_public_path__ + "img/teacher_4.8b03fe82.png";